import { itzaRules } from './itza-weighted-area.calc.js';
export const itzaRegistry = {
  domain: 'itza',
  rules: itzaRules
};
export { itzaRules };
